const DEVICE_ID_KEY = "myapp_device_id";

function generateUUID(): string {
    if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
        return crypto.randomUUID();
    }

    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0;
        const v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

/**
 * Get or create a stable per-browser device ID.
 */
export function getOrCreateDeviceId(): string {
    if (typeof window === "undefined") {
        // SSR fallback
        return generateUUID();
    }

    try {
        const existing = window.localStorage.getItem(DEVICE_ID_KEY);
        if (existing) return existing;

        const newId = generateUUID();
        window.localStorage.setItem(DEVICE_ID_KEY, newId);
        return newId;
    } catch (e) {
        console.warn("Cannot access localStorage", e);
        return generateUUID();
    }
}